var _a, _b;
import React from 'react';
import { styled } from 'goober';
import { ImportJobStatus } from '@common/api';
import { useLanguage } from '@base/LanguageProvider';
var Label = styled('span')(function (_a) {
    var theme = _a.theme, $colorType = _a.$colorType;
    return ({
        fontWeight: 700,
        fontSize: '11px',
        textTransform: 'uppercase',
        paddingLeft: '6px',
        paddingRight: '6px',
        paddingTop: '1px',
        paddingBottom: '1px',
        color: theme.colors[$colorType].w500,
        backgroundColor: theme.colors[$colorType].w50,
    });
});
var statusColorTypeMap = (_a = {},
    _a[ImportJobStatus.CREATED] = 'warning',
    _a[ImportJobStatus.COMMITED] = 'success',
    _a[ImportJobStatus.ARCHIVED] = 'function',
    _a[ImportJobStatus.REVERTED] = 'error',
    _a);
export var statusMessageMap = (_b = {},
    _b[ImportJobStatus.CREATED] = 'In progress',
    _b[ImportJobStatus.COMMITED] = 'Committed',
    _b[ImportJobStatus.ARCHIVED] = 'Archived',
    _b[ImportJobStatus.REVERTED] = 'Reverted',
    _b);
export function ImportJobStatusLabel(_a) {
    var status = _a.status;
    var L = useLanguage().L;
    var colorType = statusColorTypeMap[status];
    return React.createElement(Label, { "$colorType": colorType }, L(statusMessageMap[status]));
}
